(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["countdown-timer"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[id^="countdown-timer-"]').forEach(function (container) {
    var endDateStr = container.dataset.endDate;
    var endTimeStr = container.dataset.endTime || '23:59';
    var expiredMessage = container.dataset.expiredMessage;

    var timeParts = endTimeStr.split(':');
    var hours = parseInt(timeParts[0], 10);
    var minutes = parseInt(timeParts[1], 10);

    var dateParts = endDateStr.split('-');
    var year = parseInt(dateParts[0], 10);
    var month = parseInt(dateParts[1], 10) - 1;
    var day = parseInt(dateParts[2], 10);

    var adelaideOffsetMinutes = 10 * 60 + 30;
    var endDateTimeUTC = Date.UTC(year, month, day, hours, minutes, 0) - adelaideOffsetMinutes * 60 * 1000;

    var daysEls = container.querySelectorAll('[data-days]');
    var hoursEls = container.querySelectorAll('[data-hours]');
    var minutesEls = container.querySelectorAll('[data-minutes]');
    var secondsEls = container.querySelectorAll('[data-seconds]');
    var tickerWrapper = container.querySelector('.countdown-timer__ticker-wrapper');
    var expiredWrapper = container.querySelector('.countdown-timer__expired-wrapper');

    function updateCountdown() {
      var now = Date.now();
      var diff = endDateTimeUTC - now;

      if (diff <= 0) {
        if (tickerWrapper) tickerWrapper.style.display = 'none';
        if (expiredWrapper && expiredMessage) {
          var span = document.createElement('span');
          span.className = 'countdown-timer__expired';
          span.textContent = expiredMessage;
          expiredWrapper.innerHTML = '';
          expiredWrapper.appendChild(span);
          expiredWrapper.style.display = 'block';
        }
        return;
      }

      var days = Math.floor(diff / (1000 * 60 * 60 * 24));
      var hoursRemaining = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
      var minutesRemaining = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var secondsRemaining = Math.floor((diff % (1000 * 60)) / 1000);

      daysEls.forEach(function(el) { el.textContent = String(days).padStart(2, '0'); });
      hoursEls.forEach(function(el) { el.textContent = String(hoursRemaining).padStart(2, '0'); });
      minutesEls.forEach(function(el) { el.textContent = String(minutesRemaining).padStart(2, '0'); });
      secondsEls.forEach(function(el) { el.textContent = String(secondsRemaining).padStart(2, '0'); });

      setTimeout(updateCountdown, 1000);
    }

    updateCountdown();
  });

  } catch(e) { console.error(e); }
})();
})();
